// 图片类型，不全的话后面可以补充
export enum ImageTypes {
    GIF = 'gif',
    PNG = 'png',
    JPEG = 'jpeg',
    JPG = 'jpg',
    SVG = 'svg',
    BMP = 'bmp',
    TIFF = 'tiff',
    UNKNOWN = 'unknown',
}
